/**
 * To calculate the page number (started with 0,1,2...) to be rendered in datatable based on the input.
 *
 * Return the current page number if it is expect to have remaining item in the page after
 * removing the item.
 * Else return the last available page number ( < current page number ) that is expect to have remaining item.
 *
 * @param totalItemNum total number of items available before removing the item
 * @param removedItemNum total number of items being removed
 * @param pageSize page size
 * @param currentPage current page number (started with 0,1,2...)
 */
export const getPageNumAfterRemovingItem = (
  totalItemNum: number,
  removedItemNum: number,
  pageSize: number,
  currentPage: number
): number => {
  const remainingItemNum = totalItemNum - removedItemNum;
  const remainingAvailablePage = Math.ceil(remainingItemNum / pageSize);

  if (currentPage < remainingAvailablePage || currentPage === 0) {
    return currentPage;
  }

  // To return page number started with 0,1,2...
  return remainingAvailablePage - 1;
};
